export const qtyExceeds1000 = 'QTY_EXCEEDS_1000';

export const ForbiddenReason = {
    PASSWORD_RESET_REQUIRED: 'SECURITY_CHANGE_REQUIRED',
    ACCEPT_TERMS_REQUIRED: 'TOS_REQUIRED',
};

export const poMaskNoMatch = 'pomask.message.nonmatch';
